import React, { ReactElement } from 'react'
import SectionContainer from '../SectionContainer'
import RemoteMonitoringIcon from 'images/integrations/remote-monitoring.svg'
import ItemContainer from '../ItemContainer'
import NinjaRMM from 'images/integrations/remote-monitoring/ninja.svg'
import SolarWindsNCentral from 'images/integrations/remote-monitoring/n-central.svg'
import ConnectWiseAutomate from 'images/integrations/remote-monitoring/connect-wise.svg'
import Atera from 'images/integrations/remote-monitoring/atera.svg'
import DattoRMM from 'images/integrations/remote-monitoring/datto-rmm.svg'
import KaseyaVSA from 'images/integrations/remote-monitoring/kaseya.svg'
import ManageEngineDesktopCentral from 'images/integrations/remote-monitoring/manage-engine.svg'
import LogMeInCentral from 'images/integrations/remote-monitoring/log-me-in.svg'
import Pulseway from 'images/integrations/remote-monitoring/pulseway.svg'
import TeamViewerTensor from 'images/integrations/remote-monitoring/team-viewer.svg'

export default function RemoteMonitoringSection(): ReactElement {
  return (
    <SectionContainer
      sectionIcon={RemoteMonitoringIcon}
      title="Remote Monitoring and Management (RMM) Tools"
    >
      <ItemContainer icon={NinjaRMM} title="NinjaRMM" learnMorePath="ninjarmm-controld-tutorial" />
      <ItemContainer icon={SolarWindsNCentral} title="SolarWinds N-central" />
      <ItemContainer icon={ConnectWiseAutomate} title="ConnectWise Automate" />
      <ItemContainer icon={Atera} title="Atera" learnMorePath="atera-rmm-controld-tutorial" />
      <ItemContainer icon={DattoRMM} title="DattoRMM" learnMorePath="datto-rmm-controld-tutorial" />
      <ItemContainer icon={KaseyaVSA} title="Kaseya VSA" />
      <ItemContainer icon={ManageEngineDesktopCentral} title="ManageEngine Desktop Central" />
      <ItemContainer icon={LogMeInCentral} title="LogMeIn Central" />
      <ItemContainer icon={Pulseway} title="Pulseway" />
      <ItemContainer icon={TeamViewerTensor} title="TeamViewer Tensor" />
    </SectionContainer>
  )
}
